import * as Campos from '../constantes/Campos.js';
import * as FuncionesFechas from './FuncionesFecha.js';

export const Cuadro = {
  DATOS_BASICOS: 'datosBasicos',
  FECHAS: 'fechas',
};

export const OnCampoChange = (torneo, campo, valor) => {
  switch (campo) {
    case Campos.Torneo.DESCRIPCION: {
      return { ...torneo, descripcion: valor };
    }
    case Campos.Torneo.TIPO_TORNEO: {
      // Al cambiar tipo de torneo, limpiar país si ya no es necesario
      const nuevoTorneo = { ...torneo, tipoTorneo: valor };
      if (!valor?.oficialidad?.dePais) {
        nuevoTorneo.pais = null;
      }
      return nuevoTorneo;
    }
    case Campos.Torneo.PAIS: {
      return { ...torneo, pais: valor };
    }
    case Campos.Torneo.CATEGORIA: {
      return { ...torneo, categoria: valor };
    }
    case Campos.Torneo.ORGANIZADOR: {
      return { ...torneo, organizador: valor };
    }
    case Campos.Torneo.DIVISION: {
      return { ...torneo, division: valor };
    }
    case Campos.Torneo.TROFEO: {
      return { ...torneo, trofeo: valor };
    }
    case Campos.Torneo.TEMPORADA: {
      return { ...torneo, temporada: valor };
    }
    case Campos.Torneo.FECHA_INICIO: {
      return {
        ...torneo,
        anioInicio: valor[0],
        mesInicio: valor[1],
        diaInicio: valor[2],
      };
    }
    case Campos.Torneo.FECHA_FIN: {
      return { ...torneo, fechaFin: valor };
    }
    case Campos.Torneo.OBSERVACIONES: {
      return { ...torneo, observaciones: valor };
    }
    case Campos.Torneo.DUDAS: {
      return { ...torneo, dudas: valor };
    }
    default: {
      throw new Error('Campo ' + campo + ' no definido para Torneo');
    }
  }
};

export const OnCampoTorneoChange = (torneo, campo, valor) => {
  switch (campo) {
    case Campos.NuevoTorneo.TEMPORADA: {
      return { ...torneo, temporada: valor };
    }
    case Campos.NuevoTorneo.FECHA_INICIO: {
      return {
        ...torneo,
        anioInicio: valor[0],
        mesInicio: valor[1],
        diaInicio: valor[2],
      };
    }
    case Campos.NuevoTorneo.FECHA_FIN: {
      return { ...torneo, fechaFin: valor };
    }
    case Campos.NuevoTorneo.CATEGORIA: {
      return { ...torneo, categoria: valor };
    }
    case Campos.NuevoTorneo.TIPO_TORNEO: {
      // Al cambiar tipo de torneo, limpiar país si ya no es necesario
      const nuevoTorneo = { ...torneo, tipoTorneo: valor };
      if (!valor?.oficialidad?.dePais) {
        nuevoTorneo.pais = null;
      }
      return nuevoTorneo;
    }
    case Campos.NuevoTorneo.PAIS: {
      return { ...torneo, pais: valor };
    }
    case Campos.NuevoTorneo.NOMBRE: {
      return { ...torneo, nombre: valor };
    }
    case Campos.NuevoTorneo.CANTIDAD_PARTICIPANTES: {
      return { ...torneo, cantidadParticipantes: valor };
    }
    default: {
      throw new Error('Campo ' + campo + ' no definido para Torneo');
    }
  }
};

export const ValidarTorneo = (torneo) => {
  if (!torneo.anioInicio) {
    return 'Debe ingresar al menos el año de inicio del torneo';
  }
  if (!torneo.temporada || torneo.temporada.trim() === '') {
    return 'Debe ingresar la temporada';
  }
  if (torneo.temporada.length > 7) {
    return 'La temporada no puede tener más de 7 caracteres';
  }
  if (!torneo.categoria) {
    return 'Debe seleccionar una categoría';
  }
  if (!torneo.tipoTorneo) {
    return 'Debe seleccionar un tipo de torneo';
  }
  if (!torneo.nombre || torneo.nombre.trim() === '') {
    return 'Debe ingresar un nombre';
  }
  if (torneo.nombre.length > 50) {
    return 'El nombre no puede tener más de 50 caracteres';
  }

  // Validar coherencia de fechas inicio/fin
  if (torneo.fechaFin) {
    // Crear fecha de inicio (año, mes, día)
    const fechaInicio = FuncionesFechas.CamposToFechaBaseInicial(
      torneo.anioInicio,
      torneo.mesInicio,
      torneo.diaInicio
    );

    if (fechaInicio) {
      const fechaFin = FuncionesFechas.CamposToFechaBaseInicial(
        torneo.fechaFin[0],
        torneo.fechaFin[1],
        torneo.fechaFin[2]
      );
      if (fechaInicio > fechaFin) {
        return 'La fecha de inicio debe ser menor o igual a la fecha de fin';
      }
    }
  }

  // Validar que si el tipo de torneo requiere país, esté seleccionado
  if (torneo.tipoTorneo?.oficialidad?.dePais && !torneo.pais) {
    return 'Debe seleccionar un país para este tipo de torneo';
  }

  return '';
};
